export default "__VITE_ASSET__Bgk3VnIv__"